import { useState, useEffect } from 'react';
import { useGameStore } from '../store';

export default function PctOverlay() {
  const show         = useGameStore((s) => s.showPctOverlay);
  const setCustomPct = useGameStore((s) => s.setCustomPct);
  const [val, setVal] = useState('');

  useEffect(() => {
    if (!show) setVal('');
  }, [show]);

  if (!show) return null;

  const confirm = () => {
    const n = parseInt(val, 10);
    setCustomPct(n);
    setVal('');
  };

  const handleBackdrop = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) setCustomPct(-1);
  };

  return (
    <div id="pct-overlay" style={{ display: 'flex' }} onClick={handleBackdrop}>
      <div id="pct-sheet">
        <h3>지정 비중 설정</h3>
        <input
          id="pct-input"
          type="number"
          inputMode="numeric"
          min={1}
          max={100}
          placeholder="1~100"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && confirm()}
          autoFocus
        />
        <button id="pct-ok" onClick={confirm}>확인</button>
      </div>
    </div>
  );
}
